export type HousingProgram = "HIS" | "HMP";

export const HOUSING_PROGRAM_VALUES: readonly HousingProgram[] = ["HIS", "HMP"];

export const HOUSING_PROGRAM_ROUTE = "/his-hmp";

export const HOUSING_PROGRAM_LABELS: Record<HousingProgram, string> = {
  HIS: "HIS",
  HMP: "HMP",
};

export const HOUSING_PROGRAM_FULL_LABELS: Record<HousingProgram, string> = {
  HIS: "Habitação de Interesse Social",
  HMP: "Habitação de Mercado Popular",
};

export function normalizeHousingProgram(value: unknown): HousingProgram | null {
  if (value === "HIS" || value === "HMP") {
    return value;
  }

  return null;
}

export function getHousingProgramFromProperty(
  property: { housing_program?: unknown } | null | undefined
): HousingProgram | null {
  return normalizeHousingProgram(property?.housing_program);
}
